

import axios from "axios";
// import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_URL;
// const Token = localStorage.getItem("_ux98c_v1");


const getAllLead = (
    status,
    payload
) => {
    // const Token = localStorage.getItem("_ux98c_v1");
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        
        
        `${API_URL}/lead/getAllLead/${status}`,
        {
            params: payload,

            headers: {
                Authorization:
                    `Bearer ${token}`,
                     "Content-Type": "application/json",
            },
        }
    );

};

const getAllMasterLead = (
    status,
    payload
) => {
   const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/lead/getAllMasterLeads/${status}`,
        {
            params: payload,

            headers: {
                Authorization:
                    `Bearer ${token}`,
                     "Content-Type": "application/json",
            },
        }
    );

};


// GET UTM FILTERS
const utmFilters = async () => {

    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/lead/getUtmFilters`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const leadSource = () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/master/getAllMasterData/1`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
}

const leadpipelineoptions = () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/master/getAllMasterData/2`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
}

const businessCategory = () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/master/getAllMasterData/3`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
}

const shippingPartner = () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/master/getAllMasterData/11`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
}

const shipmentpotencialOptions = () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/master/getAllMasterData/4`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
}

const clientPersona = () => {
     const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/master/getAllMasterData/5`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
}

const leadOwner = () => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/employee/empDropdownSub`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
}

const kycdone = () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/master/getAllMasterData/21`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
}

const b2cExportExcel = (
    payload,
    
) => {
    const token = localStorage.getItem("_ux98c_v1");
    
    return axios.get(
        `${API_URL}/lead/exportLead`,
        {
            params: payload,

            responseType: "blob",

            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};
const getEmployees = () => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/employee/employees`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};


const getEmployeeLeadLoad = (
    empId,
   
) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/lead/loadOnEmployee`,
        {
            params: {
                empId,
            },

            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const bulkAssignLead = (
    formData
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/assignManyLead`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const getLeadSourceMaster =
    () => {
         const token = localStorage.getItem("_ux98c_v1");
        return axios.get(
            `${API_URL}/master/getAllMasterData/1`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

    };

const updateBulkLeadSource = (
    formData
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/updateBulkLead`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};
const getLeadStageMasterData =
    () => {
        const token = localStorage.getItem("_ux98c_v1");
        return axios.get(
            `${API_URL}/master/getAllMasterData/8`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

    };
const updateBulkLeadStage = (
    formData
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/updateBulkLead`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

// const getpipelineData =
//     () => {

//         return axios.get(
//             `${API_URL}/master/getAllMasterData/2`,
//             {
//                 headers: {
//                     Authorization: `Bearer ${Token}`,
//                 },
//             }
//         );

//     };

    const updatepipeline = (
    formData
) => {
   const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/updateBulkLead`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

 const uploadLeadExcel =
    (body) => {
        const token = localStorage.getItem("_ux98c_v1");
        return axios.post(
            `${API_URL}/lead/uploadExcel`,
            body,
            {
                headers: {
                    Authorization:
                        `Bearer ${token}`,
                },
            }
        );

    };

    const getAllStates =
    () => {
         const token = localStorage.getItem("_ux98c_v1");
        return axios.get(
            `${API_URL}/employee/allStates/101`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

    };

 const addLead = (data) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/lead/add-Lead`,
        data,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const getLeadById = (id) => {
  const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/lead/getLeadById/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type":
                    "application/json",
            },
        }
    );

};

const getLeadFollowUP = (id) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/lead/leadFollowUP/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type":
                    "application/json",
            },
        }
    );

};

const changeLeadStatus = async (
    leadId,
    formData
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return await axios.post(
        `${API_URL}/lead/changeStatus/${leadId}`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const getAllPlans = () => {
  const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/plan/getAllPlansdb`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const getAllCustomPlans = () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/plan/customPlanDropdown`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};
const getLeadStatusHistory = (leadId) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/lead/leadStatusHistory?leadId=${leadId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const getLeadContact = (leadId) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/lead/getLeadContact/${leadId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const getAllMasterData = (id) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/master/getAllMasterData/${id}`,
         {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const createLeadContact = (
    id,
    body
) => {
    const token = localStorage.getItem("_ux98c_v1");

    const formData = new FormData();

    formData.append(
        "previousContact",
        body.previousContact
    );

    return axios.post(
        `${API_URL}/lead/createLeadContact/${id}`,
        formData,
         {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

 const getKamEmployee = (
    kycType
) => {
   const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/employee/kamEmp?kycType=${kycType}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const assignLeadToKam = (
    body
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/assignLeadToKam`,
        body,
         {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

// b2cLeadService.js

// b2cleadService.js

const addCustomer = (
    empId,
    leadId
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/customer/addCustomer?empId=${empId}&leadId=${leadId}`,
        {
            id: {
                kamTypeEmployee:
                    empId,
            },

            leadId: {
                leadId:
                    leadId,
            },
        },
        {
            headers: {
                Authorization:
                    `Bearer ${token}`,
            },
        }
    );

};

const assignLead = (
    leadId,
    body
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/assignedLead/${leadId}`,
        body,
        {
            headers: {
                Authorization:
                    `Bearer ${token}`,
            },
        }
    );

};

const leadstage = (
    leadId,
    body
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/changeStatus/${leadId}`,
        body,
        {
            headers: {
                Authorization:
                    `Bearer ${token}`,
            },
        }
    );

};

const addLeadType = (
    leadId,
    body
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/addLeadType/${leadId}`,
        body,
        {
            headers: {
                Authorization:
                    `Bearer ${token}`,
            },
        }
    );

};

const postComment = (
    leadId,
    body
) => {
   const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/postComment/${leadId}`,
        body,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

export const meetingUpdate = (
    leadId,
    body
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/meetingUpdate/${leadId}`,
        body,
       {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
        
    );

};


const markMeetingDone = (
    commentId,
    body
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/changeMeetingStatus/${commentId}`,
        body,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const markcallupdateDone = (
    commentId,
    body
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/changeMeetingStatus/${commentId}`,
        body,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};



// const cancelMeeting = (
//     commentId,
//     body
// ) => {

//     return axios.post(
//         `${API_URL}/lead/cancelMeeting/${commentId}`,
//         body,
//         {
//             headers: {
//                 Authorization: `Bearer ${Token}`,
//             },
//         }
//     );

// };

const contactActivityUpdate = async (
    leadId,
    body
) => {

    // const token = localStorage.getItem("Token");
     const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/callUpdate/${leadId}`,
        body,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};


const getPlans = async () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(`${API_URL}/plan/getAllPlansdb`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const getCustomPlans = async () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(`${API_URL}/plan/customPlanDropdown`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const addQuotation = async (leadId, formData) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/lead/addQuatation/${leadId}`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const updateWonStatus = (leadId, status) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        
        `${API_URL}/lead/${status}/${leadId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const updateLostStatus = (leadId, status) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/lead/${status}/${leadId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};


 const updateLead = async (
    id,
    body
) => {
    const token = localStorage.getItem("_ux98c_v1");
    return await axios.post(
        `${API_URL}/lead/updateLead/${id}`,
        body,
          {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

};

const sendQuotationToMail = async (id) => {
    const token = localStorage.getItem("_ux98c_v1");

    return await axios.get(
        `${API_URL}/lead/send-quotation/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const sendToFship = async (id) => {
    const token = localStorage.getItem("_ux98c_v1");

    const formData = new FormData();

    formData.append("followUpId", id);

    return await axios.post(
        `${API_URL}/lead/sendQuotation`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};






export {
    getAllLead,
    getAllMasterLead,
    utmFilters,
    leadSource,
    leadpipelineoptions,
    businessCategory,
    shippingPartner,
    shipmentpotencialOptions,
    clientPersona,
    leadOwner,
    kycdone,
    b2cExportExcel,
    getEmployees,
    getEmployeeLeadLoad,
    bulkAssignLead,
    getLeadSourceMaster,
    updateBulkLeadSource,
    getLeadStageMasterData,
    updateBulkLeadStage,
    // getpipelineData,
    updatepipeline,
    uploadLeadExcel,
    getAllStates,
    addLead,
    getLeadById,
    changeLeadStatus,
    getAllPlans,
    getAllCustomPlans,
    getLeadStatusHistory,
    getLeadContact,
    getAllMasterData,
    createLeadContact,
    getKamEmployee,
    assignLeadToKam,
    addCustomer,
    assignLead,
    leadstage,
    addLeadType,
    postComment,
    getLeadFollowUP,
    markMeetingDone,
    // cancelMeeting 
    contactActivityUpdate,
    markcallupdateDone,
    getPlans,
    getCustomPlans,
    addQuotation,
    updateWonStatus,
    updateLostStatus,
    updateLead ,
    sendQuotationToMail,
    sendToFship,
};